import * as React from 'react';
import {Context} from '../../Context';
import {UseContextReturn} from './types';

/**
 * The hook get access of a task progress.
 * @return {UseContextReturn}
 */
export default function useContext(): UseContextReturn {
  const context = React.useContext(Context);

  if (context === undefined) {
    throw new Error('useContext must be used within ContextProvider');
  }

  return context;
}
